export default __webpack_public_path__ + "static/iot-45260a6ee60a547943d1b8707de17b52.svg";